import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Composer } from '../../models/composer';
import { ComposerService } from '../../services/composer.service';


@Component({
  selector: 'app-composer-dialog',
  templateUrl: './composer-dialog.component.html',
  styleUrls: ['./composer-dialog.component.scss'],
  standalone: false
})
export class ComposerDialogComponent {
  editForm: FormGroup;
  viewMode: boolean;
  showLongDesc = false; // collapsed by default

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ComposerDialogComponent>,
    private composerService: ComposerService,
    @Inject(MAT_DIALOG_DATA) public data: { composer: Composer | null; viewMode: boolean }
  ) {
    this.viewMode = data.viewMode;
    this.editForm = this.fb.group({
      id: [data.composer?.id || 0],
      surname: [data.composer?.surname || ''],
      fullName: [data.composer?.fullName || ''],
      countryOfBirth: [data.composer?.countryOfBirth || ''],
      yearOfBirth: [data.composer?.yearOfBirth || null],
      yearOfDeath: [data.composer?.yearOfDeath || null],
      descriptionShort: [data.composer?.descriptionShort || ''],
      descriptionLong: [data.composer?.descriptionLong || ''],
      resourceFolder: [data.composer?.resourceFolder || '']
    });
  }

  saveChanges(): void {
    if (!this.editForm.valid) return;
    const raw = this.editForm.value as any;
    const payload: any = { ...raw };
    // Normalize optional numeric fields
    payload.yearOfBirth = raw.yearOfBirth === '' || raw.yearOfBirth === undefined || raw.yearOfBirth === null ? null : Number(raw.yearOfBirth);
    payload.yearOfDeath = raw.yearOfDeath === '' || raw.yearOfDeath === undefined || raw.yearOfDeath === null ? null : Number(raw.yearOfDeath);

    if (!payload.id || payload.id === 0) {
      delete payload.id;
      this.composerService.createComposer(payload).subscribe({
        next: () => this.dialogRef.close(true),
        error: (err) => {
          console.error('Failed to create composer', err);
          alert('Failed to create composer. Please check required fields and try again.');
        }
      });
    } else {
      this.composerService.updateComposer(payload.id, payload).subscribe({
        next: () => this.dialogRef.close(true),
        error: (err) => {
          console.error('Failed to update composer', err);
          alert('Failed to update composer. Please check the values and try again.');
        }
      });
    }
  }

  closeDialog(): void {
    this.dialogRef.close(null); // Close the dialog without saving
  }

  toggleLongDesc(): void {
    this.showLongDesc = !this.showLongDesc;
  }
}

